"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isError = void 0;

var _ramda = require("ramda");

var isError = function isError(error, serverErrors) {
  return !!(0, _ramda.pathEq)(['graphQLErrors', 0, 'message'], error, serverErrors) || !!(0, _ramda.pathEq)(['data', 'message'], error, serverErrors) || !!(0, _ramda.pathEq)(['message'], error, serverErrors);
};

exports.isError = isError;